var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignoutDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 31.8748C26.1771 35.7845 22.9197 39.1031 18.556 38.9975C17.5406 38.9722 16.2844 38.6176 13.7743 37.9103C7.73444 36.2067 2.49044 33.342 1.23222 26.9264C1 25.7506 1 24.4227 1 21.767V18.233C1 15.5794 1 14.2515 1.23222 13.0715C2.49044 6.65802 7.73444 3.79329 13.7743 2.08965C16.2866 1.38244 17.5406 1.02778 18.556 1.00245C22.9197 0.896897 26.1771 4.2155 26.3333 8.12521M39 20H15.7778M39 20C39 18.5222 34.7904 15.761 33.7222 14.7223M39 20C39 21.4778 34.7904 24.239 33.7222 25.2777",
    stroke: "#F1F1F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutDark);
export default __webpack_public_path__ + "static/media/signout-dark.eecca05ef5c5a5ebb5c0b0aa13a08c6c.svg";
export { ForwardRef as ReactComponent };